import * as Mod1 from "./discourse/connectors/user-preferences-nav/saved-searches.gjs";
import * as Mod2 from "./discourse/controllers/preferences/saved-searches";
import * as Mod3 from "./discourse/discourse-saved-searches-route-map";
import * as Mod4 from "./discourse/initializers/saved-searches";
import * as Mod5 from "./discourse/routes/preferences/saved-searches";
import * as Mod6 from "./discourse/templates/preferences/saved-searches";
const compatModules = {
  "discourse/connectors/user-preferences-nav/saved-searches": Mod1,
  "discourse/controllers/preferences/saved-searches": Mod2,
  "discourse/discourse-saved-searches-route-map": Mod3,
  "discourse/initializers/saved-searches": Mod4,
  "discourse/routes/preferences/saved-searches": Mod5,
  "discourse/templates/preferences/saved-searches": Mod6,
};
export { compatModules };
export default compatModules;
